import React, { useState } from 'react';
import ProjectCard from '../components/ProjectCard';
import ProjectModal from '../components/ProjectModal';

function Projects() {
  const projects = [
    {
      title: 'Project 1: Job Analytics Dashboard',
      description: 'A full-featured React dashboard for tracking job applications, visualizing analytics, and managing the job search process. Built with modern frontend technologies and designed to simulate a real SaaS product.',
      tech: ['React', 'Vite' , 'API' , 'Firebase' , 'AUTH'],
      demo: 'https://bittmoon.github.io/jobtracker/',
      github: 'https://github.com/bittmoon/jobtracker',
      screenshot: require('../screenshots/job-an.png'),
    },
    {
      title: 'Project 2: Arcade landing page',
      description: 'A modern, responsive landing page focused on layout design, accessibility, and performance using CSS Grid and Flexbox.',
      tech: ['React', 'CSS', 'GitHub Pages'],
      demo: 'https://bittmoon.github.io/arcade-landing-page',
      github: 'https://github.com/bittmoon/arcade-landing-page',
      screenshot: require('../screenshots/arcade-landing.png'),
    },
    {
      title: 'Project 3: Smart expense tracker',
      description: 'A responsive React application for tracking income and expenses with persistent storage and real-time balance calculation.',
      tech: ['React', 'Hooks', 'CSS', 'Local Storage'],
      demo: 'https://bittmoon.github.io/smart-expense-tracker',
      github: 'https://github.com/bittmoon/smart-expense-tracker',
      screenshot: require('../screenshots/smart-expense.png'),
    },
    {
      title: 'Project 4: job-application-tracker',
      description: 'A React app for tracking job applications across different stages. Built to practice clean component structure, state management, and practical UI design.',
      tech: ['React', 'JavaScript' , 'CSS' , 'Local Storage'],
      demo: 'https://bittmoon.github.io/job-application-tracker/',
      github: 'https://github.com/bittmoon/job-application-tracker',
      screenshot: require('../screenshots/job-app.png'),
    },
    // Add up to 4 projects
  ];

  const [selected, setSelected] = useState(null);

  return (
    <section id="projects" className="relative overflow-hidden py-24" aria-labelledby="projects-title" style={{ transitionDelay: '0.14s' }}>
      <h2 id="projects-title" className="text-3xl font-bold mb-8 text-center">Projects</h2>
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
        {projects.map((project, index) => (
          <ProjectCard key={index} project={project} onOpen={() => setSelected(project)} />
        ))}
      </div>

      <ProjectModal project={selected} open={!!selected} onClose={() => setSelected(null)} />
    </section>
  );
}

export default Projects;